<template>
    <v-flex xs12>
        <v-card>
            <v-card-title primary-title>
                <h3 class="headline mx-auto">Form Kelompok</h3>
            </v-card-title>
            <v-card-actions>
                <v-layout row>
                    <v-flex xs12>
                        <form @submit.prevent="save" ref="form">
                            <v-text-field
                                    label="Nama Kelompok"
                                    name="form.name"
                                    v-model="form.name"
                                    :error-messages="name_errors"
                                    @blur="$v.form.name.$touch()"
                                    @input="$v.form.name.$touch()"
                                    required
                            ></v-text-field>

                            <v-layout row wrap align-center justify-center>
                                <v-flex xs10>
                                    <v-autocomplete
                                            label="Instansi"
                                            v-model="form.instansi_id"
                                            :loading="instansi_id_loading"
                                            :items="instansi_id_items"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="instansi_id_errors"
                                            @blur="$v.form.instansi_id.$touch()"
                                            @input="$v.form.instansi_id.$touch()"
                                            clearable
                                            hint="Jika instansi tidak ada, silahkan tambahkan dengan mengklik tombol (+)"
                                            persistent-hint
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs2 text-xs-center>
                                    <v-dialog v-model="dialog_instansi" max-width="600px" persistent>
                                        <template v-slot:activator="{ on }">
                                            <v-btn fab dark small color="info" v-on="on"><v-icon dark>add</v-icon></v-btn>
                                        </template>
                                        <InstansiForm @close="closeDialogInstansi"></InstansiForm>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap align-center justify-center my-4>
                                <v-flex xs12 sm12 md5 ma-2>
                                    <v-btn name="simpan" type="submit" block color="primary" class="ma-0">Simpan</v-btn>
                                </v-flex>
                                <v-flex xs12 sm12 md5 ma-2>
                                    <v-btn block color="red darker-3" class="ma-0" @click="close">Batal</v-btn>
                                </v-flex>
                            </v-layout>
                        </form>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
    import {validationMixin} from 'vuelidate';
    import {required} from 'vuelidate/lib/validators';
    import InstansiAPI from '@/api/instansi';
    import KelompokAPI from '@/api/kelompok';
    import InstansiForm from '@/components/instansi/Form';
    import swal from "sweetalert2";
    import router from '@/router/index';
    import moment from 'moment';

    export default {
        props: ['uuid'],
        mixins: [validationMixin],
        components: {
            InstansiForm,
        },
        validations: {
            form: {
                name: {required},
                instansi_id: {required},
            },
        },

        data: () => {
            return {
                form: {
                    name: null,
                    instansi_id: null,
                    is_primary: false,
                },
                instansi_id_items: [],
                instansi_id_loading: false,
                dialog_instansi: false,
            }
        },

        watch: {
            uuid: function(newVal, oldVal) {
                this.loadData();
            },
        },

        computed: {
            name_errors() {
                const errors = [];
                if (!this.$v.form.name.$dirty) return errors;
                !this.$v.form.name.required && errors.push('Name harus diisi.');
                return errors;
            },
            instansi_id_errors() {
                const errors = [];
                if (!this.$v.form.instansi_id.$dirty) return errors;
                !this.$v.form.instansi_id.required && errors.push('Instansi harus diisi.');
                return errors;
            },
        },

        mounted: function(){
            this.load_instansi_id_items();
        },

        methods: {
            loadData(){
                KelompokAPI.loadData(this.uuid).then(response => {
                    let {name, instansi_id} = response.data.results.data;

                    this.form = {
                        name: name,
                        instansi_id: instansi_id,
                    }
                });
            },
            resetForm(){
                this.form = {
                    name: null,
                    instansi_id: null,
                    is_primary: false,
                };
            },
            close() {
                this.$emit('close');
                this.resetForm();
            },
            async save() {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {
                    this.$store.dispatch("loading/start");
                    KelompokAPI.save(this.form).then(response => {
                        this.$store.dispatch("loading/stop");
                        swal.fire({
                            type: 'info',
                            text: response.data.results.message + "!",
                            reverseButtons: false,
                            confirmButtonText: 'ok',
                        }).then(function(){
                            this.close();
                        }.bind(this));
                    });
                }
            },
            load_instansi_id_items(val = '') {
                let search_column = ["name"];

                let params = [];
                for(let idx in search_column) {
                    params.push(search_column[idx]+':'+val);
                }

                this.instansi_id_loading = true;
                this.$store.dispatch("loading/start");
                InstansiAPI.loadOptions(params)
                    .then(response => {
                        this.$store.dispatch("loading/stop");
                        this.instansi_id_items = response.data.results.data;
                        this.instansi_id_loading = false;
                    }).catch(error => {
                    console.log(error.response)
                });
            },
            closeDialogInstansi(){
                this.dialog_instansi = false;
                this.load_instansi_id_items();
            },
        }
    }
</script>
